// import logo from './logo.svg';
import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import {Login} from './Admin/Login';
import {AdminLogin} from './Admin/AdminLogin';
import {SuperLogin} from './Admin/SuperLogin';
import {Admin} from './Admin/Admin';
import {UserDashboard} from './Admin/UserDashboard';
import {Users} from './Admin/Users';
import {Students} from './Admin/Students';
import {AddOrganization} from './Admin/AddOrganization';
import {AddStudent} from './Admin/AddStudent';
import {EditOrganization} from './Admin/EditOrganization';
import {EditStudent} from './Admin/EditStudent';
import {EditExam} from './Admin/EditExam';
import {EditTest} from './Admin/EditTest';
import {Results} from './Admin/Results';
import {ViewResult} from './Admin/ViewResult';
import {Exams} from './Admin/Exams';
import {Tests} from './Admin/Tests';
import {ViewTest} from './Admin/ViewTest';
import {ViewTestSchedule} from './Admin/ViewTestSchedule';
import {UserTest} from './Admin/UserTest';
import {AddExam} from './Admin/AddExam';
import {AddTest} from './Admin/AddTest';
import {AddTestSchedule} from './Admin/AddTestSchedule';
import {EditTestSchedule} from './Admin/EditTestSchedule';
import {TestSchedules} from './Admin/TestSchedules';
import {AddQuestion} from './Admin/AddQuestion';
import {ThankYou} from './Admin/ThankYou';
import {MyTest} from './Admin/MyTest';
import {TrackExam} from './Admin/TrackExam';
// import SocketSetup from "./SocketSetup";
import { useAuth } from './AuthContext';
import StudentAnalytics from './Admin/StudentAnalytics';
import ExamAnalytics from './Admin/Analytics';
import Analytics from './Admin/Analytics';

function App() {
  return (
    <>
    {/* <SocketSetup token={token} usertype={usertype} /> */}
    <Router>
      <Routes>
        <Route exact path='/' element={ <Login /> } />
        <Route exact path='/admin' element={ <AdminLogin /> } />
        <Route exact path='/student_analytics' element={ <StudentAnalytics /> } />
        <Route exact path='/exam_analytics' element={ <ExamAnalytics /> } />
        <Route exact path='/analytics' element={ <Analytics /> } />
        <Route exact path='/super_admin' element={ <SuperLogin /> } />
        <Route exact path='/dashboard' element={ <Admin /> } />
        <Route exact path='/student_dashboard' element={ <UserDashboard /> } />
        <Route exact path='/users' element={ <Users /> } />
        <Route exact path='/students' element={ <Students /> } />
        <Route exact path='/add_student' element={ <AddStudent /> } />
        <Route exact path='/edit_organization' element={ <EditOrganization /> } />
        <Route exact path='/edit_student' element={ <EditStudent /> } />
        <Route exact path='/edit_exam' element={ <EditExam /> } />
        <Route exact path='/edit_test' element={ <EditTest /> } />
        <Route exact path='/edit_test_schedule' element={ <EditTestSchedule /> } />
        <Route exact path='/add_organization' element={ <AddOrganization /> } />
        <Route exact path='/exams' element={ <Exams /> } />
        <Route exact path='/tests' element={ <Tests /> } />
        <Route exact path='/view_test_schedule' element={ <ViewTestSchedule /> } />
        <Route exact path='/view_test' element={ <ViewTest /> } />
        <Route exact path='/user_test' element={ <UserTest /> } />
        <Route exact path='/add_exam' element={ <AddExam /> } />
        <Route exact path='/add_question' element={ <AddQuestion /> } />
        <Route exact path='/add_test' element={ <AddTest /> } />
        <Route exact path='/add_test_schedule' element={ <AddTestSchedule /> } />
        <Route exact path='/test_schedules' element={ <TestSchedules /> } />
        <Route exact path='/my_test' element={ <MyTest /> } />
        <Route exact path='/thanks' element={ <ThankYou /> } />
        <Route exact path='/results' element={ <Results /> } />
        <Route exact path='/view_result' element={ <ViewResult /> } />
        <Route exact path='/live_exam' element={ <TrackExam /> } />
      </Routes>
    </Router>
    </>
  )
}


export default App;
